/**
 * This is the maximum length managed by the backend for a search query
 */
export const MAX_QUERY_LENGTH = 500;
